import { useCallback, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { adminActions } from './actions'
import {
  selectPendingOrdersCount
} from './selectors'
import { selectUser, selectIsAuthenticated } from '../auth/selectors'

/**
 * Hook para usar funcionalidades de Admin com Redux
 * Mantém compatibilidade com a interface antiga do AdminContext
 */
export const useAdmin = () => {
  const dispatch = useAppDispatch()
  const pendingOrdersCount = useAppSelector(selectPendingOrdersCount)
  const user = useAppSelector(selectUser)
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const isAdmin = user?.role === 'ADMIN'

  const refreshPendingOrders = useCallback(async () => {
    if (isAuthenticated && isAdmin) {
      dispatch(adminActions.fetchPendingOrdersCountRequest())
    }
  }, [dispatch, isAuthenticated, isAdmin])

  // Carregar contagem de pedidos pendentes quando usuário for admin
  useEffect(() => {
    if (isAuthenticated && isAdmin) {
      dispatch(adminActions.fetchPendingOrdersCountRequest())
    }
  }, [dispatch, isAuthenticated, isAdmin])

  return {
    pendingOrdersCount,
    refreshPendingOrders
  }
}

